import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';
import { Empty_Protocol17025ChartFile_Interface, Protocol17025ChartFile_Interface } from 'src/app/Interface/Protocol17025/Protocol17025ChartFile_Interface';
import { Empty_Protocol17025Chart_Interface, Protocol17025Chart_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Chart_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { Protocol17025ChartFileService } from 'src/app/Service/Protocol17025/Protocol17025ChartFile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-Protocol17025ChartFile',
  templateUrl: './Protocol17025ChartFile.component.html',
  styleUrls: ['./Protocol17025ChartFile.component.scss']
})
export class Protocol17025ChartFileComponent implements OnInit {

  @Input() inner_17025_Cat: Protocol17025Chart_Interface = Empty_Protocol17025Chart_Interface()
  @Output() On_Back_Action = new EventEmitter<number>();
  Switcher_Viewer: string = 'List'
  FileName: string = ''
  Selected_Protocol17025ChartFile:Protocol17025ChartFile_Interface=Empty_Protocol17025ChartFile_Interface()
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl
  page=0
  DataList_ChartFile:Array<Protocol17025ChartFile_Interface>=[]

  constructor(
    private Protocol17025ChartFile_Service: Protocol17025ChartFileService,
    private Alerify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Get_DataList()
  }

  Set_Switcher_Viewer(item: string,id:number)
  {
    this.Switcher_Viewer = item
    if (item == 'Form')
      this.GetRecord(id)
  }

  OnSet_Back_Action() {
    this.On_Back_Action.emit(0);
  }

  Get_DataList()
  {
    this.Procssing=true
    this.Protocol17025ChartFile_Service.GetRecord(this.inner_17025_Cat.id).subscribe(
      data => {
        this.Procssing=false
        this.DataList_ChartFile=data
      },
      error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  //#region Form

  InProccessingAdd:boolean=false
  Selected_Tag: Array<Protocol17025Cat_Interface> = []
  DataList_Protocol17025Cat: Array<Protocol17025Cat_Interface> = []


  OnGet_Selected_Tag(item: Array<Protocol17025Cat_Interface>)
  {
    this.Selected_Tag = item
  }

  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessingAdd=true

    this.Protocol17025ChartFile_Service.uploadPdf(formData,this.inner_17025_Cat.id).subscribe(
      data=>{
        this.InProccessingAdd=false
        if(data['dsc'])
        {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alerify_Service.SuccessMessage("فایل بارگذاری شد")
          this.FileName=data['fodlername']

        }
      }
    )

  }

  AddEdit() {


    var tag_id:Array<number>=[]
    for (let item of this.Selected_Tag)
      tag_id.push(item.id)

    if (!this.FileName.trim() && this.Selected_Protocol17025ChartFile.id==0) {
      this.Alerify_Service.ErrorMessage("فایل مورد نظر را بارگذاری نمائید..")
    }
    else {

      var temp: Protocol17025ChartFile_Interface = Empty_Protocol17025ChartFile_Interface()
      temp.id=this.Selected_Protocol17025ChartFile.id
      temp.title=this.Selected_Protocol17025ChartFile.title
      temp.dsc = this.Selected_Protocol17025ChartFile.dsc
      temp.src = this.FileName
      temp.chart_id=this.inner_17025_Cat.id

      this.Protocol17025ChartFile_Service.AddEdit(temp,tag_id).subscribe(
        data => {
          this.Alerify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.Get_DataList()
        },
        error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }


  GetRecord(id:number)
  {
    this.Protocol17025ChartFile_Service.GetSingle(id).subscribe(
      data => {
        this.DataList_Protocol17025Cat = data['tag']
        this.Selected_Protocol17025ChartFile.id=data['record']['id']
        this.Selected_Protocol17025ChartFile.title=data['record']['title']
        this.Selected_Protocol17025ChartFile.dsc = data['record']['dsc']

        this.Selected_Tag = data['selectedTag']
      },
      error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion


  //#region Delete

  modalRef_Delete: any;
  Delete(item: Protocol17025ChartFile_Interface) {
    this.Procssing = true
    this.modalRef_Delete.hide()
    this.Protocol17025ChartFile_Service.Delete(item.id).subscribe(
      data => {
        this.Procssing = false
        this.Alerify_Service.SuccessMessage("حذف شد")
        this.Get_DataList()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Selected_Protocol17025ChartFile = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  //#endregion

}
